// Human-readable names for rules, used on cards, in dialogs and in error messages.
const FORMATTING = {
  b: "Bold", i: "Italic", u: "Underline", strike: "Strikethrough",
  "small-caps": "Small caps", "all-caps": "All caps", highlight: "Highlight",
};
const CATCH_ALL = { p: "Any paragraph", r: "Any text run", table: "Any table" };
const KIND_LABELS = {
  paragraph: "Paragraph style", character: "Character style", table: "Table style",
  list: "List", formatting: "Formatting", other: "Custom mapping",
};

export function ruleName(rule) {
  if (rule.raw !== undefined) return rule.raw;
  if (rule.style) return rule.prefix ? `${rule.style}…` : rule.style;
  const list = /^(ul|ol)([1-5])$/.exec(rule.match);
  if (list) return `${list[1] === "ul" ? "Bulleted" : "Numbered"} list · level ${list[2]}`;
  return FORMATTING[rule.match] ?? CATCH_ALL[rule.match] ?? rule.match;
}

export function ruleKind(rule) {
  if (rule.raw !== undefined) return "other";
  if (rule.match === "p") return "paragraph";
  if (rule.match === "r") return "character";
  if (rule.match === "table") return "table";
  if (/^(ul|ol)[1-5]$/.test(rule.match)) return "list";
  return "formatting";
}

export function kindLabel(rule) {
  const parts = [KIND_LABELS[ruleKind(rule)]];
  if (rule.prefix) parts.push("starts with");
  if (rule.group === "quiet") parts.push("plain");
  if (rule.priority === "first") parts.push("always wins");
  if (rule.priority === "last") parts.push("always loses");
  return parts.join(" · ");
}
